module.exports = __webpack_public_path__ + "img/06_Schnupperangebot-Preis.24e7ce19.svg";